import { useContext } from 'react';
import { InboundContext } from '../../../../context/InboundContext';
import { FormGroup, PhoneInput, AddressLineOneField } from '../../../common';
import { Heading } from '../../../styledComponents';
import { getLocationDetails } from '../../../../services/dashboard.service';
import styles from '../FormContainer.module.css';
import CountrySelect from '../../../common/CustomSelect/CountrySelect/CountrySelect';
import { handleAddressInputChange } from '../../../../utils/validations';

type AddressDetailsType = {
  addressLineOne: string;
  addressLineTwo: string;
  pincode: string;
  city: string;
  state: string;
  country: string;
  phone: string;
};

type AddressDetailsProps = {
  address: AddressDetailsType;
  setAddress: React.Dispatch<React.SetStateAction<AddressDetailsType>>;
};

export default function AddressDetails({ address, setAddress }: AddressDetailsProps) {
  const { inboundData, t } = useContext(InboundContext);

  const handleFetchLocation = async (zipcode: string) => {
    const data = await getLocationDetails(zipcode);
    setAddress((prev) => ({ ...prev, ...data }));
  };

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    handleAddressInputChange(e, setAddress, handleFetchLocation);
  };

  return (
    <div>
      {inboundData?.formSetupPage?.address && (
        <div className={styles.formSection}>
          <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
            {t('shippingAddressHeader')}
          </Heading>
          <br />
          <AddressLineOneField
            label={t('addressLabel')}
            placeholder={t('addressPlaceholder')}
            value={address.addressLineOne}
            onChange={handleInputChange}
            errorMessages={{
              minLengthErrorMessage: t('addressLineOneMinLengthError'),
              maxLengthErrorMessage: t('addressLineOneMaxLengthError'),
            }}
            required
          />
          <div className={styles.group}>
            <FormGroup
              id="addressLineTwo"
              name="addressLineTwo"
              label={t('apartmentLabel')}
              type="text"
              placeholder={t('apartmentPlaceholder')}
              value={address.addressLineTwo}
              onChange={handleInputChange}
              errorText=""
            />
            <FormGroup
              id="pincode"
              name="pincode"
              label={t('postalCodeLabel')}
              type="text"
              placeholder={t('postalCodePlaceholder')}
              value={address.pincode}
              onChange={handleInputChange}
              errorText=""
              required
            />
          </div>
          <FormGroup
            id="city"
            name="city"
            label={t('cityLabel')}
            type="text"
            placeholder={t('cityPlaceholder')}
            value={address.city}
            onChange={handleInputChange}
            errorText=""
            required
          />
          <FormGroup
            id="state"
            name="state"
            label={t('stateLabel')}
            type="text"
            placeholder={t('statePlaceholder')}
            value={address.state}
            onChange={handleInputChange}
            errorText=""
            required
          />

          <CountrySelect
            value={address.country}
            setValue={(value) => setAddress((prev) => ({ ...prev, country: value }))}
            placeholder={t('countryPlaceholder')}
            label={t('countryLabel')}
            wrapperClassName={styles.countrySelectWrapper}
          />
          <PhoneInput
            value={address.phone}
            onChange={(phone) => {
              setAddress((add) => ({ ...add, phone }));
            }}
            id="phone"
            label={t('phoneLabel')}
          />
        </div>
      )}
    </div>
  );
}
